import { css } from '@emotion/react';
import { getVideoBlurhash, getVideoPosterJpgByAspectRatio, roundRobinCDN, } from '@core/helpers/video';
import { usePreferredCDNs } from '@core/helpers/video/usePreferredCDNs';
import { useContextParams } from '@core/params/context';
import ThumbnailPicture from '@embed/components/common/ThumbnailPicture';
import { THUMBNAIL_SIZE_LARGE } from '@embed/styled';
/**
 * Thumbnail which alternates between vertical and horizontal
 * video static poster based on the container's aspect ratio.
 */
export const ThumbnailPictureByOrientation = ({ video, ...props }) => {
    const params = useContextParams();
    const preferredCDNs = usePreferredCDNs(params);
    const verticalSize = THUMBNAIL_SIZE_LARGE;
    const horizontalSize = [...THUMBNAIL_SIZE_LARGE].sort((a, b) => b - a);
    const verticalPoster = roundRobinCDN(getVideoPosterJpgByAspectRatio(video, '1:2'), preferredCDNs);
    const horizontalPoster = roundRobinCDN(getVideoPosterJpgByAspectRatio(video, '2:1'), preferredCDNs);
    const defaultSize = video.width / video.height >= 1 ? horizontalSize : verticalSize;
    const defaultPoster = roundRobinCDN(video.thumbnail_url, preferredCDNs);
    return (<div css={css `
        position: relative;
        container-type: size;
        container-name: thumbnail-container;
        contain: layout style size;
        width: 100%;
        height: 100%;
      `}>
      <div className="cy-vertical" css={css `
          position: relative;
          width: 100%;
          height: 100%;
          display: block;

          @container thumbnail-container (aspect-ratio <= 1) {
            display: block;
          }
          @container thumbnail-container (aspect-ratio > 1) {
            display: none;
          }
        `}>
        <ThumbnailPicture {...props} src={verticalPoster || horizontalPoster || defaultPoster} loading="lazy" blurhash={getVideoBlurhash(video)} // TODO(CS-8987): Actual poster blurhash, not video placeholder blurhash
     options={{
            size: verticalPoster
                ? verticalSize
                : horizontalPoster
                    ? horizontalSize
                    : defaultSize,
            fit: true,
        }}/>
      </div>
      <div className="cy-horizontal" css={css `
          position: relative;
          width: 100%;
          height: 100%;
          display: none;

          @container thumbnail-container (aspect-ratio <= 1) {
            display: none;
          }
          @container thumbnail-container (aspect-ratio > 1) {
            display: block;
          }
        `}>
        <ThumbnailPicture {...props} src={horizontalPoster || verticalPoster || defaultPoster} loading="lazy" blurhash={getVideoBlurhash(video)} // TODO(CS-8987): Actual poster blurhash, not video placeholder blurhash
     options={{
            size: horizontalPoster
                ? horizontalSize
                : verticalPoster
                    ? verticalSize
                    : defaultSize,
            fit: true,
        }}/>
      </div>
    </div>);
};
